import { createContext, useContext } from 'react';
import { useSettings } from '@/features/settings';
import { useHouseholdData } from './HouseholdDataProvider';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const { data, save } = useHouseholdData();
  const settings = useSettings(data, save);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSettingsContext() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettingsContext must be used within SettingsProvider');
  return ctx;
}
